<template>
  <div class="card">
    <WCImage
      v-if="giftCard.design"
      :imageSrc="`${$configuration.cdn}/api/img/${giftCard.design.image}`"
      :imageAlt="giftCard.design.description || $t('giftCardImgAltText')"
      imageClass="gift-card-preview__img"
      defaultClass="font-size-7xl"
    />
    <div class="pl-2">
      <div class="font-weight-bold">
        {{ $t('amount') }}: {{ (giftCard.amount ? giftCard.amount : 0) | currency }}
      </div>
      <div class="font-weight-bold">{{ $t('toCap') }}: {{ giftCard.recipientName }}</div>
      <div class="font-weight-bold">{{ $t('from') }}: {{ giftCard.senderName }}</div>
      <p v-if="giftCard.message">{{ $t('message') }}: {{ giftCard.message }}</p>
    </div>
  </div>
</template>
<script>
import WCImage from '@/components/WCImage/WCImage.vue';

export default {
  props: {
    giftCard: {
      Type: Object,
    },
  },
  components: { WCImage },
  data() {
    return {};
  },
};
</script>
<style lang="scss">
.gift-card-preview__img {
  width: 100%;
}
</style>
